import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import sal from "sal.js";
import { Helmet } from "@dr.pogodin/react-helmet";


export default function Zimbra() {
  useEffect(() => {
    document.title = "How Zimbra Mail Server Can Transform Your Business Emails";
          sal();
        }, []);
  return (
    <>
    <Helmet>
        <title>How Zimbra Mail Server Can Transform Your Business Emails</title>
        <meta name="description" content="Secure, fast, and easy-to-manage email services with Zimbra Mail Server, perfect for businesses seeking reliable messaging and advanced collaboration features." />
        <meta name="keywords" content="Zimbra Smtp, Zimbra Email Server, Smtp Server For Zimbra, Zimbra Smtp Server, Inbox Zimbra, Zimbra mail server" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/zimbra-mail-server`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/zimbra-mail-server`} />
        <meta property="og:title" content="Best Zimbra Email Server provider - Zimbra Email Server Hosting" />
        <meta property="og:description" content="Optimize your email communication with Zimbra Mail Server. Infinitive Host offers the Zimbra mail service that manages all the emails with your existing systems" />
    </Helmet>
    <section className="banner-bg bg-dark server-banner special-tilt-pb">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                    <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Unforgettable Zimbra Hosting Starts Here.
                    </span>
                    <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Emails Shouldn’t Be a Guessing Game: Get Zimbra Mail Server.
                    </h1>
                    <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        Sick of hitting that “send” button & crossing fingers for the best? With the help of our Zimbra mail server, there’s no more space for “what ifs.” You get best delivery, real-time sync, & security so your mail’s inbox works according to you, not against you.
                    </p>
                    <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <Link to="/contact-us" className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                            <span className="btn-arrow__text">
                                Get Started
                                <span className="btn-arrow__icon">
                                    <i className="fa-solid fa-arrow-right"></i>
                                </span>
                            </span>
                        </Link>
                    </div>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                    <img src="/images/emails-shouldn-be.webp" alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine"/>
                </div>
            </div>
        </div>
    </section>

      <section className="domain-container position-relative z-1 overflow-hidden">
              <div className="container">
                  <div className="row justify-content-center">
                      <div className="col-xl-10">
                          <div className="card cta-wrapper-one rounded-4 domain-container-inner">
                              <div className="card-body pt-60 pb-60">
                                  <div className="row justify-content-center">
                                    <div className="col-md-11 col-lg-10 col-xl-10">
                                        <div className="text-center">
                                          <span className="section-title style-bg fadeInUp mb-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Smart. Secure. Zimbra.</span>
                                            <h4 className="mb-4">
                                                Try Zimbra Mail Server Today, Thank Us Later.
                                            </h4>
                                            <p className="mb-6">
                                              You might question Zimbra now-but once you see how flawlessly Zimbra powers all your emails, collaboration, and peace of mind, you'll surely say, "Why not switch sooner?"
                                            </p>
                                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded me-sm-2 btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    +91-7737300013
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                            <Link to="#" className="btn btn-primary btn-arrow btn-arrow-xl btn-lg fs-14 fw-medium rounded ms-sm-2 mt-sm-0 mt-4 open-live-chat btn-height">
                                                <span className="d-inline-block me-1 flex-shrink-0">
                                                    <i className="las la-comments"></i>
                                                </span>
                                                <span className="btn-arrow__text">
                                                    Talk to an Expert
                                                    <span className="btn-arrow__icon">
                                                        <i className="fa-solid fa-arrow-right"></i>
                                                    </span>
                                                </span>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
      </section>

      <div className="pt-100 pb-100 linux-hosting-points-section">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center justify-content-xl-between">
                    <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                            <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Mail Without Limits.
                        </small>
                        <h2 className="mb-4">
                            Zimbra Email: Because Your Email Deserves More Than Just “Hosting”
                        </h2>
                        <p className="max-text-56 mb-0 fw-semibold">
                            Your email should be as hardworking as you are. With the help of Zimbra email, expect seamless collaboration, top-notch security, and no more drama.
                        </p>
                    </div>
                    <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                        <div className="card">
                            <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row g-4">
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/work-without-borders.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Work Without Borders
                            </h6>
                            <p className="mb-0">
                                Sick of being tied to one place? Zimbra mail server always gives you the full freedom to work from anywhere, without restrictions.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/10-gbps.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Up & Running in a Blink
                            </h6>
                            <p className="mb-0">
                                No more long setups, no more tech issues. Our Zimbra hosting installs in a single click-are you ready to scale as fast as your goals boost?
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/inbox-detox-starts.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Mail That Really Shows Up
                            </h6>
                            <p className="mb-0">
                                You have got huge emails to manage-our Zimbra mail server is top-notch, reliable, and engineered especially to never let you down.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/stay-steps-ahead.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Stay Steps Ahead of Threats
                            </h6>
                            <p className="mb-0">
                                Stressed about threats or spam sneaking in? Our Zimbra hosting protects you with security that always stops danger before it even starts.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/strong-core-smart.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                No More Oops Moment
                            </h6>
                            <p className="mb-0">
                                Crashes happen unexpectedly. But with our Zimbra email, your data stays secure-all thanks to automated backups running every day.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                    <div className="card border-0 shadow-sm rounded-4 h-100">
                        <div className="card-body p-md-6 p-xl-8">
                            <div className="mb-8">
                                <img src="/images/pay-a-little-get.webp" alt="image" className="img-fluid"/>
                            </div>
                            <h6 className="mb-4">
                                Pay a Little, Get a Lot
                            </h6>
                            <p className="mb-0">
                                Why pay extra money? With the help of our Zimbra hosting, you save big on all hardware & storage-no more compromise with quality.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <section className="pb-20">
      <div className="pb-40">
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-md-10 col-lg-8 col-xl-6">
                      <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="300" data-sal-delay="50" data-sal-easing="ease-in-out-sine">
                          <h3>Zimbra: Email Hosting That Feels Like Magic</h3>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div className="container">
          <div className="row g-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
              <div className="col-lg-5">
                  <div className="card h-100">
                      <div className="card-body p-xl-6">
                          <div className="text-center pb-4">
                              <img src="images/feature-img-1.png" alt="image" className="img-fluid" /> 
                          </div>
                          <h5 className="pb-4">
                              What Zimbra Hosting Syncs With (Spoiler Alert: A Lot)
                          </h5>
                          <p className="mb-2">
                              Do you think Zimbra mail server is just an email like others? Huhhh… Then, think again. With the help of smart syncing, a 99.9% uptime guarantee, and 24/7 real human support, our Zimbra hosting always gives you more power and less struggle, all under a chosen plan.
                          </p>
                      </div>
                  </div>
              </div>
              <div className="col-lg-7">
                  <div className="row g-4">
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/browsers-covered.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Browsers? Covered.
                                  </h6>
                                  <p className="mb-7">
                                      Works smoothly on Google Chrome, Safari, Firefox, Edge, and a lot more. Just open and start.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/we-dont-pick.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      We Don’t Pick Favorites
                                  </h6>
                                  <p className="mb-7">
                                      Fully compatible with Thunderbird, Outlook, Apple Mail, & many more-just plug in and begin.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/zimbra-ios-ready.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Zimbra, iOS-Ready
                                  </h6>
                                  <p className="mb-7">
                                      Instantly access your Zimbra email account in no time with the help of iOS Mail or any email app.
                                  </p>
                              </div>
                          </div>
                      </div>
                      <div className="col-md-6">
                          <div className="card h-100">
                              <div className="card-body p-xl-6">
                                  <div className="mb-10">
                                      <img src="images/android-or-windows.webp" alt="image" className="img-fluid" />
                                  </div>
                                  <h6>
                                      Android or Windows? All Set
                                  </h6>
                                  <p className="mb-7">
                                      Stay connected with anyone-24/7, anywhere-Zimbra works smoothly on your favorite devices.
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

      <section className="bg-light-13 pt-10 pb-100">
        <div className="container">
            <div className="row">
                <div className="col-xl-9">
                    <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>Enterprise Mail, Simplified.</small>
                    <h2 className="mb-0">From Inbox to Impact: Zimbra Mail Server Always Keeps You Moving</h2>
                </div>
            </div>
            <div className="mt-12">
                <div className="row g-4">
                    <div className="col-lg-4">
                        <div className="bg-primary p-5 rounded-3 h-100">
                            <div className="bg-white p-4 rounded-3 mb-8">
                                <div className="text-center">
                                    <img src="/images/support.png" alt="Image" className="img-fluid mb-3"/>
                                    <h6 className="mb-2">Infinitive Support</h6>
                                    <p className="mb-4">Technical Support specialists</p>
                                    <div className="style_15 d-inline-flex align-items-center justify-content-center gap-2">
                                        <Link to="https://wa.me/+917742553946?text=I recently check out your official website and was impressed by your web hosting solutions. I’m ready to buy a web hosting plan that matches my requirements. Could you please help me through the process?" target="_blank" rel="noopener noreferrer" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-whatsapp"></i></span>
                                        </Link>
                                        <Link to="https://www.instagram.com/infinitive_host" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-instagram"></i></span>
                                        </Link>
                                        <Link to="https://www.linkedin.com/company/infinitivehost/" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-linkedin-in"></i></span>
                                        </Link>
                                        <Link to="https://www.facebook.com/InfinitiveHost-435551663445191" target="_blank" className="social-icon w-9 h-9 d-inline-flex align-items-center justify-content-center rounded-circle border border-dark border-opacity-10">
                                            <span className="text-body"><i className="fa-brands fa-facebook-f"></i></span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            <h6 className="text-white mb-3">Zimbra Support, 24x7</h6>
                            <p className="text-white mb-4">Stuck in the middle of the night? We are right here. Get real, manual help 24×7-call or chat. Zimbra hosting help is just a message away.</p>
                            <Link to="#" className="btn btn-light border-0 btn-arrow btn-arrow-md fs-14 fw-medium rounded open-live-chat btn-height">
                                <span className="btn-arrow__text">
                                    LiveChat
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-8 ipad-mt">
                        <div className="row g-4">
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/your-inbox-new-bff.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Your Inbox’s New BFF</h6>
                                    <p className="mb-0">One missed email can cost you a worthy deal. Zimbra makes sure that you never miss a beat-quick and engineered for real-life work.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/spam-cant-talk-with-us.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Spam Can’t Talk With Us</h6>
                                    <p className="mb-0">The Zimbra mail server always keep every spam and phishing threat out, so your inbox stays pure, clean, protected, and focused on what matters.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/ctrl-z-doesnt-work-on-emails.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Ctrl+Z Doesn’t Work on Emails</h6>
                                    <p className="mb-0">Accidentally deleted something? With Zimbra’s automated backups, you don’t need any magic-just real-time support to get your emails back.</p>
                                  </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="card h-100">
                                  <div className="card-body p-xl-6">
                                    <img src="/images/junk-emails-stop-at-the-gate.webp" alt="Image" className="img-fluid mb-5"/>
                                    <h6 className="mb-5">Junk Emails Stop at the Gate</h6>
                                    <p className="mb-0">Is spam blocking your workflow? Don’t worry, with the help of our Zimbra mail server, it blocks all the junk and always keeps your inbox clean.</p>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/say-hiiii-to-the-smarter.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Power Your Inbox.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Say Hiiii to the Smarter Side of Email
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Our Zimbra Mail Server always comes with cutting-edge anti-spam filters that easily block all suspicious emails and phishing attempts-usually keeping your Zimbra mailbox protected and ready for challenging tasks.
                            </p>
                            <ul>
                                <li><b>Money-Smart Moves</b></li>
                                <p>With our Zimbra hosting plans, you cut down on unnecessary costs while focusing more of your energy on boosting your email campaigns.</p>
                                <li><b>Ping Us Anytime</b></li>
                                <p>Server problems won’t easily slow you down. Our experts are available 24×7 to monitor & handle your service for email, ensuring high uptime.</p>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Built for Business Mail.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                From Backups to Browsers: Hosting for Large Teams
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Improve your email experience with Infinitive Host’s Zimbra email hosting. Our scalable Zimbra mail server guarantees seamless webmail access across all demanded browsers and mobile devices-anytime, anywhere.
                            </p>
                            <ul>
                                <li><b>Spam? Not Here.</b></li>
                                <p>Always keep your Zimbra mailbox clean and safe with all the built-in spam filters and automatic backups that protect your data 24/7.</p>
                                <li><b>Email. Backed Up.</b></li>
                                <p>Our Zimbra email hosting guarantees that your data is always secure with automated, hassle-free cloud backups-available anytime.</p>
                            </ul>
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/from-backups-to-browsers.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="pb-60">
        <div className="pb-60">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/zimbra-hosting-from.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                    <div className="col-md-6 order-lg-1 order-0">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Work Mail, Done Right.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Zimbra Hosting: From Small Teams to Big Dreams
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Infinitive Host is a fully reliable partner for delivering trustworthy & flexible Zimbra email hosting all over India. Our budget-friendly servers adapt to your increasing demands-while always keeping your email protected.
                            </p>
                            <p className="mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <b>Benefits? Oh My God, We’ve Got Plenty.</b>
                            </p>
                            <ul>
                                <li>99.99% uptime + full backup & recovery</li>
                                <li>24×7×365 hands-on expert support</li>
                                <li>Smooth integration with third-party apps & Zimlets</li>
                                <li>India’s leading Linux server compatibility</li>
                                <li>Works like a charm on iPhone, Android & Windows</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="pb-10">
            <div className="container">
                <div className="row g-4 align-items-center">
                    <div className="col-md-6">
                        <div className="ps-lg-8 pe-xxl-12">
                            <span className="d-block mb-2 text-primary fs-18 fw-semibold sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Email With Authority.
                            </span>
                            <h3 className="mb-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                Work Faster, Email Better: Everything at Infinitive Host
                            </h3>
                            <p data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" className="sal-animate">
                                Get smooth communication along with our Zimbra hosting service, especially for email-engineered to always keep your team effective. Get instant access, smooth sharing, and robust teamwork, all in one place.
                            </p>
                            <p className="mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                                <b>Let’s Break Down the Advantages</b>
                            </p>
                            <ul>
                                <li>India’s best Zimbra mail hosting</li>
                                <li>Works seamlessly on Linux, Windows, etc.</li>
                                <li>Quick file sharing and collaboration tools</li>
                                <li>Well storage with robust server control</li>
                                <li>Sleek AJAX-powered interface along with sharing options</li>
                            </ul>
                            <Link to="/contact-us" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Get Started Now
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                        <img src="images/work-faster-email-better.webp" alt="image" className="img-fluid full-width-img" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section className="pb-100">
        <div className="container">
            <div className="cta-wrapper-one pt-60 pb-60 px-6 rounded-3">
                <div className="row justify-content-center">
                    <div className="col-xxl-7 col-xl-9">
                        <div className="d-flex justify-content-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <div className="px-3 py-1 border border-primary rounded d-inline-flex align-items-center gap-2">
                                <div className="w-2 h-2 rounded-circle bg-primary"></div>
                                <small className="text-primary fw-bold">Mail that Means Business.</small>
                            </div>
                        </div>
                        <div className="text-center mt-5">
                            <h2 className="mb-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Start Your Mailing Journey Now!</h2>
                            <p className="mb-8 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">Don’t Only Send Emails: Command All of Them with Zimbra Hosting. </p>
                        </div>
                        <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap flex-md-nowrap sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine">
                            <Link to="/frequently-asked-questions" className="btn btn-dark btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                                <span className="btn-arrow__text">
                                    Learn More
                                    <span className="btn-arrow__icon">
                                        <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </>
  );
}
